
import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator'
import CancelButton from '../buttons/CancelButton.vue'
import WarnButton from '../buttons/WarnButton.vue'
import EditFrame from '../EditFrame.vue'

@Component({
  components: {
    EditFrame,
    CancelButton,
    WarnButton
  }
})
export default class WarnDialog extends Vue {
  @ModelSync('value', 'input')
  show!: boolean

  @Prop({ default: 'Achtung!' })
  title!: string

  @Prop({ default: 'Löschen' })
  dangerActionText!: string

  onCancel () {
    this.show = false
    this.$emit('cancel')
  }

  onConfirm () {
    this.show = false
    this.$emit('confirm')
  }
}
